import { Handler } from '~services';
import { settings } from '~api';

import { Setting } from '~models';
import router from '~router';
import { updateField } from 'vuex-map-fields';
import i18n from '../i18n';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const SET_SETTING = 'SET_SETTING';
const SET_SETTING_INDEX = 'SET_SETTING_INDEX';
const SET_SETTINGS = 'SET_SETTINGS';
const RESET_SETTING = 'RESET_SETTING';
const LOADING = 'LOADING';

dayjs.extend(utc);
const state = {
    setting: { ...new Setting() },
    isLoading: false,
    settings: [],
    settingIndex: null
};

const actions = {
    toggleLoading({ commit }) {
        commit(LOADING);
    },

    /**
     * Reset Setting state and redirect to list.
     * @param {function} commit
     */
    cancel({ commit }) {
        router.push({ name: 'dashboard.admin.settings' });
        commit(RESET_SETTING);
    },

    /**
     * Update Setting value.
     * @param  {string} name
     * @param  {string | boolean | number} value
     * @returns {Promise<void>}
     */
    async update({ commit }, { name, value }) {
        const successMessage = i18n.t('settings.messages.successMessage');
        const errorMessage = i18n.t('settings.messages.errorMessage');
        commit(LOADING);

        const resp = await settings.update(name, value);

        // Show Notification and make redirect
        Handler.handleResponse(resp, successMessage, errorMessage);

        commit(LOADING);
    },

    /**
     * Get Setting by name.
     * @param {function} commit
     * @param  {string} name
     */
    async get({ commit }, { name }) {
        let resp = await settings.get(name);

        if (resp.ok) {
            const { data } = resp;
            commit(SET_SETTING, { data });
        } else {
            // Handle response if error
            Handler.handleResponse(resp);
        }
    },

    /**
     * Get all Settings.
     * @param {function} commit
     */
    async list({ commit }) {
        let resp = await settings.list();

        if (resp.ok) {
            commit(SET_SETTINGS, resp.data);
        } else {
            // Handle response if error
            Handler.handleResponse(resp);
        }
    }
};

const mutations = {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
    [SET_SETTING](state, data) {
        state.setting = data;
    },
    [SET_SETTING_INDEX](state, i) {
        state.settingIndex = i;
    },
    [RESET_SETTING](state) {
        state.setting = { ...new Setting() };
    },
    [SET_SETTINGS](state, data) {
        if (state.settingIndex > data.length - 1) {
            state.settingIndex = 0;
        }
        if (state.settingIndex === null && data.length > 0) {
            state.settingIndex = 0;
        }
        state.settings = data;
    },

    [LOADING](state) {
        state.isLoading = !state.isLoading;
    }
};

const getters = {
    isLoading: state => state.isLoading,
    setting: state => {
        if (state.settingIndex !== null) {
            return state.settings[state.settingIndex];
        }
        return null;
    },
    settings: state => state.settings
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
